var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderMain"},_vm._l((_vm.scheduleList),function(item,index){return _c('div',{key:index,staticClass:"order"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.tip))]),_c('div',{staticClass:"main"},[_vm._v(_vm._s(item.text))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(item.time))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }